import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {

    let target = section.applicant === 1 ? `applicant1` : `applicant2`

    const questions = [
        {
            name: 'institution',
            label: 'Bank Name',
            answer: {
                type: 'text',
            },
            target: `${target}.employmentIncome[${section.index}].businessBankName`
        },
        {
            name: 'iban',
            label: 'IBAN',
            answer: {
                type: 'text',
            },
            target: `${target}.employmentIncome[${section.index}].businessBankAccountNumber`
        }
    ]
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
    );
}


export default ApplicationForm;